import { AuthorType, GetKeywordSearchMagazineQuery } from '@/types/bff/gql-schema';
import { MagazineBottomButtonType } from '@/types/magazine';
import { EAuthorType, MagazineSearchResultVo } from '@/types/search';
import { SearchResult } from '@/types/search';
import dayjs from 'dayjs';
import { useGetKeywordSearchMagazineQuery } from './search.gql.impl';

const KEYWORD_SEARCH_SIZE = 4;

const parseAuthorType = (authorType: AuthorType): EAuthorType => {
  switch (authorType) {
    case AuthorType.Doctor:
      return EAuthorType.Doctor;
    case AuthorType.Nurse:
      return EAuthorType.Nurse;
    case AuthorType.Ai:
      return EAuthorType.Ai;
    case AuthorType.GeneralEditor:
      return EAuthorType.GeneralEditor;
    case AuthorType.MedicalProfessionalEditor:
      return EAuthorType.MedicalProfessionalEditor;
  }
};

const parseKeywordIntegratedSearchMagazineVo = (
  data: GetKeywordSearchMagazineQuery
): SearchResult<MagazineSearchResultVo> => {
  return {
    hasMore: data.keywordSearchMagazineCursorPage.elements.length > 3,
    elements: data.keywordSearchMagazineCursorPage.elements.slice(0, 3).map((magazine) => {
      return {
        ...magazine,
        author: magazine.author
          ? {
              ...magazine.author,
              authorType: parseAuthorType(magazine.author.authorType),
            }
          : undefined,
        bottomButtonType: magazine.bottomButtonType as MagazineBottomButtonType,
        createdDate: `${dayjs(magazine.createdAt).format('YYYY.MM.DD')}`,
      };
    }),
  };
};

const useGetKeywordIntegratedSearchMagazine = (keyword: string) => {
  const { data: keywordSearchMagazine, isLoading: isKeywordSearchMagazineLoading } = useGetKeywordSearchMagazineQuery(
    {
      request: {
        keyword,
        size: KEYWORD_SEARCH_SIZE,
      },
    },
    {
      select: parseKeywordIntegratedSearchMagazineVo,
      enabled: keyword.length > 1,
    }
  );

  return {
    keywordSearchMagazine,
    isKeywordSearchMagazineLoading,
  };
};

export default useGetKeywordIntegratedSearchMagazine;
